$(document).ready(function () {
    customer.base.mdbootstrap();
});